ALLOWED_CONTROLLER = 'reports'
ALLOWED_ACTIONS = ['location_details']


ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS) || !!document.querySelector('turbo-frame#location_details_report')

  updatePeriodAndSubmit = (e) ->
    e.preventDefault()
    $("input#start_date").val($(this).attr('data-start'))
    $("input#end_date").val($(this).attr('data-end'))

    document.querySelector("form[data-selector='main-form']").requestSubmit()

  $("input[data-selector='period-button']").on 'click', updatePeriodAndSubmit

$(document).ready(ready)
$(document).on('turbo:frame-render', ready)
